import { render, staticRenderFns } from "./CardTemplateTable.vue?vue&type=template&id=53ec90ea&scoped=true"
import script from "./CardTemplateTable.vue?vue&type=script&lang=js"
export * from "./CardTemplateTable.vue?vue&type=script&lang=js"
import style0 from "./CardTemplateTable.vue?vue&type=style&index=0&id=53ec90ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ec90ea",
  null
  
)

export default component.exports